<nz-drawer
  [nzVisible]="isOpen"
  nzTitle="Payment details"
  nzPlacement="right"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzKeyboard]="true"
  (nzOnClose)="onClose()"
  [nzWidth]="drawerWidth"
  class="payment-details-drawer"
>
  <ng-container *nzDrawerContent>
    <ng-container *ngIf="payment">
      <div class="drawer-heading">
        <p class="payment-id">Payment ID {{ payment.id }}</p>
        <nz-tag class="status-tag" [nzColor]="statusColor">{{ statusText }}</nz-tag>
      </div>

      <nz-divider></nz-divider>

      <p class="section-title">Application</p>
      <div class="section-box">
        <div class="row">
          <span class="label">Application ID</span>
          <a *ngIf="applicationLink; else applicationIdPlain" class="value link" [routerLink]="applicationLink">{{ applicationLabel }}</a>
          <ng-template #applicationIdPlain><span class="value">{{ applicationLabel }}</span></ng-template>
        </div>
        <div class="row">
          <span class="label">Type</span>
          <span class="value">{{ applicationChannelText }}</span>
        </div>
        <div class="row" *ngIf="details?.applicationStatus">
          <span class="label">Status</span>
          <nz-tag class="status-tag" [nzColor]="applicationStatusColor">{{ applicationStatusText }}</nz-tag>
        </div>
        <div class="row">
          <span class="label">Service</span>
          <span class="value">{{ details?.service || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Submission date</span>
          <span class="value">{{ (details?.submissionDate || payment.createdAt) ? ((details?.submissionDate || payment.createdAt) | date: 'dd.MM.yyyy') : '—' }}</span>
        </div>
      </div>

      <nz-divider></nz-divider>

      <p class="section-title">Payer</p>
      <ng-container *ngIf="payer as party; else payerPlaceholder">
        <div class="section-box">
          <div class="row">
            <span class="label">{{ party.isBodyCorporate ? 'Company Name' : 'Name' }}</span>
            <span class="value">{{ party.name || '—' }}</span>
          </div>
          <div class="row" *ngIf="party.iin">
            <span class="label">IIN</span>
            <span class="value">{{ party.iin }}</span>
          </div>
          <div class="row" *ngIf="party.bin">
            <span class="label">BIN</span>
            <span class="value">{{ party.bin }}</span>
          </div>
          <div class="row" *ngIf="party.country">
            <span class="label">{{ party.isBodyCorporate ? 'Country' : 'Country of Citizenship' }}</span>
            <span class="value">{{ party.country }}</span>
          </div>
          <div class="row">
            <span class="label">Address</span>
            <span class="value">{{ party.address || '—' }}</span>
          </div>
          <div class="row">
            <span class="label">Email</span>
            <a *ngIf="party.email; else noPayerEmail" class="value link" href="mailto:{{ party.email }}">{{ party.email }}</a>
            <ng-template #noPayerEmail><span class="value">—</span></ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template #payerPlaceholder>
        <div class="section-box-empty">—</div>
      </ng-template>

      <nz-divider></nz-divider>

      <p class="section-title">Biller</p>
      <ng-container *ngIf="biller as party; else billerPlaceholder">
        <div class="section-box">
          <div class="row">
            <span class="label">{{ party.isBodyCorporate ? 'Company Name' : 'Name' }}</span>
            <span class="value">{{ party.name || '—' }}</span>
          </div>
          <div class="row" *ngIf="party.iin">
            <span class="label">IIN</span>
            <span class="value">{{ party.iin }}</span>
          </div>
          <div class="row" *ngIf="party.bin">
            <span class="label">BIN</span>
            <span class="value">{{ party.bin }}</span>
          </div>
          <div class="row" *ngIf="party.country">
            <span class="label">{{ party.isBodyCorporate ? 'Country' : 'Country of Citizenship' }}</span>
            <span class="value">{{ party.country }}</span>
          </div>
          <div class="row">
            <span class="label">Address</span>
            <span class="value">{{ party.address || '—' }}</span>
          </div>
          <div class="row">
            <span class="label">Email</span>
            <a *ngIf="party.email; else noBillerEmail" class="value link" href="mailto:{{ party.email }}">{{ party.email }}</a>
            <ng-template #noBillerEmail><span class="value">—</span></ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template #billerPlaceholder>
        <div class="section-box-empty">—</div>
      </ng-template>

      <nz-divider></nz-divider>

      <p class="section-title">Payment</p>
      <div class="section-box">
        <div class="row">
          <span class="label">Payment Order</span>
          <span class="value">{{ details?.paymentOrder || payment.paymentOrder || payment.epayReference || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Payment Invoice</span>
          <span class="value">{{ details?.invoiceNumber || payment.invoiceNumber || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Amount</span>
          <span class="value">{{ details?.amount ?? '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Currency</span>
          <span class="value">{{ details?.currency || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Card</span>
          <span class="value">{{ details?.cardMask || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">IPS</span>
          <span class="value">{{ details?.ips || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Issuer</span>
          <span class="value">{{ details?.issuer || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">RRN</span>
          <span class="value">{{ details?.rrn || '—' }}</span>
        </div>
        <div class="row">
          <span class="label">Payment date</span>
          <span class="value">{{ (details?.paymentDate || payment.paymentDate) ? ((details?.paymentDate || payment.paymentDate) | date: 'dd.MM.yyyy') : '—' }}</span>
        </div>
      </div>

      <nz-divider></nz-divider>

      <div class="status-history-header">
        <p class="section-title">Status history</p>
        <span class="step-count" *ngIf="currentStepNumber">Step {{ currentStepNumber }} of {{ statusHistorySteps.length }}</span>
      </div>

      <div class="status-steps">
        <div class="status-step" *ngFor="let step of statusHistorySteps; let last = last">
          <div class="step-icon-wrapper">
            <div class="step-icon" [ngClass]="'step-icon-' + step.state">
              <span *ngIf="step.state !== 'future'" nz-icon nzType="check" nzTheme="outline"></span>
            </div>
            <div class="step-tail" *ngIf="!last"></div>
          </div>
          <div class="step-body">
            <div class="step-text-row">
              <span class="step-label" [class.step-label-current]="step.state === 'current'">{{ step.label }}</span>
              <span class="step-timestamp" *ngIf="step.timestamp">{{ step.timestamp | date: 'dd.MM HH:mm' }}</span>
            </div>
            <div class="step-error" *ngFor="let error of step.errors" [ngClass]="'step-error-' + error.severity.toLowerCase()">
              <span class="step-error-message">{{ error.message }}</span>
              <span class="step-error-date">{{ error.occurredAt | date: 'dd.MM.yyyy HH:mm' }}</span>
            </div>
          </div>
        </div>
      </div>

      <nz-divider></nz-divider>

      <p class="section-title">Attachments</p>
      <div class="documents-list">
        <div class="document-item" *ngFor="let doc of documents" [class.document-item-disabled]="!doc.available">
          <i nz-icon nzType="file-pdf" nzTheme="outline" class="document-icon"></i>
          <a *ngIf="doc.available; else documentUnavailable" class="document-name" (click)="downloadDocument(doc)">{{ documentDisplayName(doc) }}</a>
          <ng-template #documentUnavailable>
            <span class="document-name document-name-disabled">{{ documentDisplayName(doc) }} — not generated</span>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </ng-container>
</nz-drawer>
